import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import CompanySettings from "@/pages/CompanySettings";
import UsersPage from "@/pages/Users";
import Campaigns from "@/pages/Campaigns";
import CampaignWizard from "@/pages/CampaignWizard";
import Prospects from "@/pages/Prospects";
import Leads from "@/pages/LeadsToday";
import Pipeline from "@/pages/Pipeline";
import Stats from "@/pages/Stats";
import Calendar from "@/pages/Calendar";
import WeeklyReport from "@/pages/WeeklyReport";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const GuestOnly = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined)
    return <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">Chargement…</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/prospects" element={<Prospects />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/statistiques" element={<Stats />} />
            <Route path="/calendrier" element={<Calendar />} />
            <Route path="/rapport-hebdo" element={<WeeklyReport />} />
            <Route path="/campagnes" element={<Campaigns />} />
            <Route path="/campagnes/nouvelle" element={<CampaignWizard />} />
            <Route path="/campagnes/:id" element={<CampaignWizard />} />
            <Route path="/entreprise" element={<CompanySettings />} />
            <Route path="/utilisateurs" element={<UsersPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
